import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VisibilityService {

  constructor() { }

  isVisible(element: HTMLElement) {
    return new Promise(resolve => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          resolve(entry.isIntersecting);
          observer.disconnect();
        }
      });

      observer.observe(element);
    });
  }
}
